import { createContext } from "react";
import {
  IReceiveAndReferenceForDepartment,
  IReceiveAndReferenceForUser
} from "../../generated/graphql";
import { IEmployeeInformation } from "./approval-process/list-of-selected-approval-user";
import { IAdjustTime } from "./approval-form/components/DateTimeFields";
import { UploadUserInfo } from "../upload-files/types";
import type { WorkPolicyApplicationController } from "./approval-form/work-policy/use-work-policy-application-controller";

export interface IAttachedFile {
  name: string;
  size: number;
}

export interface IApprovalDetailPopupStore {
  listOfUser: IEmployeeInformation[];
  listOfReceiveUser: IReceiveAndReferenceForUser[];
  listOfReceiveDepartment: IReceiveAndReferenceForDepartment[];
  listOfReferenceUser: IReceiveAndReferenceForUser[];
  listOfReferenceDepartment: IReceiveAndReferenceForDepartment[];
  startDate?: string;
  endDate?: string;
  formTemplateIdx?: number;
  formIdx?: number;
  startTime?: string;
  endTime?: string;
  description?: string;
  replacementRequestStartDate?: string;
  replacementRequestEndDate?: string;
  replacementRequestStartTime?: string;
  replacementRequestEndTime?: string;
  approvalRequestIdx?: number;
  workingTemplateIdx: number;
  setWorkingTemplateIdx: (workingTemplateIdx: number) => void;
  isTemporaryStorage?: boolean;
  adjustTimes?: IAdjustTime[];
  uploadUserInfo?: UploadUserInfo;
  setUploadUserInfo: (uploadUserInfo: UploadUserInfo) => void;
  attachedFiles: IAttachedFile[];
  setAttachedFiles: (attachedFiles: IAttachedFile[]) => void;
  setAdjustTimes: (adjustTimes: IAdjustTime[]) => void;
  workPolicyApplication?: WorkPolicyApplicationController;
}

const ApprovalDetailPopupStore = createContext<
  IApprovalDetailPopupStore | undefined
>(undefined);

export default ApprovalDetailPopupStore;
